<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="spesenartForm" autocomplete=off>

    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.bezeichnung' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.zeitverwaltung.spesenartDialog.bezeichnung' | translate"
        formControlName="bezeichnung"
      />
    </mat-form-field>

    <div class="zweiLinien">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.code' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenartDialog.code' | translate"
          formControlName="code"
        />
      </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.ansatzInt' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.zeitverwaltung.spesenartDialog.ansatzInt' | translate"
        formControlName="ansatzInt"
        [decimalNumbersOnlyMax]="1000000"
        [kommaStellen]="2"
      />
    </mat-form-field>


      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.ansatzExt' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenartDialog.ansatzExt' | translate"
          formControlName="ansatzExt"
          [decimalNumbersOnlyMax]="1000000"
          [kommaStellen]="2"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.konto' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenartDialog.konto' | translate"
          formControlName="konto"
          [evenNumbersOnlyMax]="9999"
        />
      </mat-form-field>

    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="spesenartForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
